/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type FinancialProps = {
  product: AbstractCase;
};

const Financial = ({ product }: FinancialProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Finanzen</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"netIncomePetitioner"} />
      <SummaryDetailsItem caseData={product} fieldPath={"netIncomePartner"} />
      {!product.shortMarriage && <SummaryDetailsItem caseData={product} fieldPath={"pensionsExcluded"} />}
      {product.pensionsExcluded === false && (
        <>
          <SummaryDetailsItem caseData={product} fieldPath={"numberPensions"} />
          <SummaryDetailsItem caseData={product} fieldPath={"numberPensionsPartner"} />
          <SummaryDetailsItem caseData={product} fieldPath={"pensionsQuestions"} />
        </>
      )}
      {product.netIncomePetitioner <= 1200 && product.paymentType !== "insurance" && (
        <SummaryDetailsItem caseData={product} fieldPath={"hasProcessCostSupport"} />
      )}
    </>
  );
};

export default Financial;
